import { instances } from '@/services/http';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import type {
  UserDashboardSubmitUgcContentRequestType,
  UserDashboardSubmitUgcContentResponseType,
} from '@magma-app/magma-types/user-dashboard/ugc';

export const useSubmitContent = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: UserDashboardSubmitUgcContentRequestType) => {
      const { userUgcId, ...body } = payload;
      const response = await instances.userDashboard.put(
        `ugcs/${userUgcId}/content`,
        body
      );

      return response.data as UserDashboardSubmitUgcContentResponseType;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ugcs'] });
    },
  });
};
